export const PROJECTS_URL = "https://brain.rakeshkadam.me/";

export const toolProjects: Record<string, string[]> = {
  "Docker": ["FinTech & Web3 Infrastructure", "Internal Observability", "Digital Brain", "Side Projects"],
  "Docker Compose": ["FinTech & Web3 Infrastructure", "Internal Observability"],
  "Kubernetes": ["Internal Observability", "Digital Brain", "Side Projects"],
  "Kind": ["Digital Brain"],
  "Helm": ["Internal Observability"],
  "Traefik": ["FinTech & Web3 Infrastructure"],
  "NestJS": ["FinTech & Web3 Infrastructure"],

  "Teleport": ["Internal Observability"],
  "Loki": ["Internal Observability"],
  "Grafana Alloy": ["Internal Observability"],
  "Grafana": ["Internal Observability", "Digital Brain"],
  "Prometheus": ["Internal Observability"],

  "Quartz": ["Digital Brain"],
  "Cloudflare": ["Digital Brain", "FinTech & Web3 Infrastructure"],
  "Cloudflare Tunnel": ["Digital Brain"],
  "AI Ingest": ["Digital Brain"],

  "Python": ["Side Projects", "Digital Brain"],
  "TypeScript": ["Side Projects", "FinTech & Web3 Infrastructure", "Digital Brain"],
  "Bash": ["Internal Observability", "Side Projects"],
  "Node.js": ["FinTech & Web3 Infrastructure", "Side Projects"],

  "Terraform": ["FinTech & Web3 Infrastructure", "Internal Observability"],
  "AWS": ["FinTech & Web3 Infrastructure"],
  "EC2": ["FinTech & Web3 Infrastructure"],
  "VPC": ["FinTech & Web3 Infrastructure"],

  "Redis": ["FinTech & Web3 Infrastructure"],
  "PostgreSQL": ["FinTech & Web3 Infrastructure", "Side Projects"],
  "MongoDB": ["Side Projects"],

  "Claude Code": ["Digital Brain", "Side Projects"],
  "LLM Agents": ["Digital Brain"],
  "OpenAI": ["Digital Brain"],

  "TLS": ["FinTech & Web3 Infrastructure", "Internal Observability"],
  "Zero-Trust": ["Internal Observability"],
  "RBAC": ["Internal Observability", "Digital Brain"],

  "REST": ["FinTech & Web3 Infrastructure", "Side Projects"],
  "gRPC": ["FinTech & Web3 Infrastructure"],
  "WebSockets": ["Side Projects"],
  "GraphQL": ["Side Projects"],

  "Nginx": ["FinTech & Web3 Infrastructure"],
  "systemd": ["Internal Observability"],
  "Linux": ["Internal Observability", "FinTech & Web3 Infrastructure"],

  "GitHub Actions": ["Digital Brain", "Side Projects", "FinTech & Web3 Infrastructure"],
  "CI/CD": ["FinTech & Web3 Infrastructure", "Internal Observability", "Digital Brain"],
  "GitOps": ["Internal Observability"],

  "Markdown": ["Digital Brain"],
  "MkDocs": ["Digital Brain"],

  "ECS": ["FinTech & Web3 Infrastructure", "Internal Observability"],
  "EKS": ["FinTech & Web3 Infrastructure"],
  "ECR": ["FinTech & Web3 Infrastructure"],
  "S3": ["FinTech & Web3 Infrastructure", "Digital Brain"],
  "Lambda": ["FinTech & Web3 Infrastructure"],
  "ElastiCache": ["FinTech & Web3 Infrastructure"],
  "Secrets Manager": ["FinTech & Web3 Infrastructure", "Internal Observability"],
  "SSM": ["FinTech & Web3 Infrastructure"],
  "Aurora": ["FinTech & Web3 Infrastructure"],
  "API Gateway": ["FinTech & Web3 Infrastructure"],
  "WAF": ["FinTech & Web3 Infrastructure"],
  "CloudFront": ["FinTech & Web3 Infrastructure", "Digital Brain"],
  "RDS": ["FinTech & Web3 Infrastructure", "Side Projects"],
  "Route53": ["FinTech & Web3 Infrastructure", "Digital Brain"],
  "CloudFormation": ["FinTech & Web3 Infrastructure"],
  "Bitbucket Pipelines": ["FinTech & Web3 Infrastructure"],
  "Jenkins": ["FinTech & Web3 Infrastructure"],
  "GitLab CI": ["FinTech & Web3 Infrastructure"],
  "Nx monorepos": ["FinTech & Web3 Infrastructure"],
  "OIDC authentication": ["FinTech & Web3 Infrastructure", "Internal Observability"],
};
